module.exports = __webpack_public_path__ + "img/autoconta_sin_fondo.ab6318bb.png";